var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 125,
    height: 27,
    viewBox: "0 0 125 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1759",
    "data-name": "Group 1759",
    transform: "translate(-832 -470)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Items",
    transform: "translate(863 490)",
    fill: "#02071a",
    fontSize: 19,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600,
    letterSpacing: "-0.048em",
    opacity: 0.724
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Link music")), /*#__PURE__*/React.createElement("path", {
    id: "Path_1629",
    "data-name": "Path 1629",
    d: "M12,3l.01,10.55A3.995,3.995,0,1,0,14,17V7h4V3ZM10.01,19a2,2,0,1,1,2-2A2.006,2.006,0,0,1,10.01,19Z",
    transform: "translate(826 472)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkMusic);
export default __webpack_public_path__ + "static/media/link-music.d24150f6.svg";
export { ForwardRef as ReactComponent };